const mFeedMapsContentModalCreate = {
  mFeedMapsContentModalCreate: {
    alerts: {
      createMapa: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El mapa fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      titulo: {
        label: 'Escribe aquí un nombre',
        message: '* De 5 a 120 caracteres'
      }
    },

    title: 'Nuevo Mapa de Aprendizaje',

    validation: {
      titulo: {
        maxLength: 'La longitud máxima permitida es de 120 caracteres.',
        minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'Nombre de mapa es requerido. De 5 a 120 caracteres.'
      }
    }
  }
}

export default mFeedMapsContentModalCreate
